import React from 'react';

import {
    Avatar,
    Card,
    // CardBody,
    CardHeader,
    // Center,
    Divider,
    Flex,
    // HStack,
    Link,
    // Stack,
} from '@chakra-ui/react';
import parse from 'html-react-parser';

// import logo from '@assets/home_work.svg';
import linkedInLogo from '@assets/linkedin-logo.svg';
import { Loader } from '@components/custom-loader';
import { CustomText } from '@components/Custom-text';
// import CustomTag from '@components/Custom-text/CustomTag';
// import { TimelineData } from '@data-types/generic';
import { CompanyLogo } from '@components/logo/CompanyLogo';
import { Mentor } from '@modules/auth/types';

// import Achievements from '../sections/Achievements';
// import ProfileInfo from '../sections/ProfileInfo';
// import ProfileInfoTabs from '../sections/ProfileInfoTabs';

interface MentorPublicProfileCardProps {
    mentorFullProfileInfo: Mentor;
    isLoading: boolean;
    // experiences: TimelineData[];
    // academics: TimelineData[];
    // achievements: string[];
}

const MentorPublicProfileCard = ({
    mentorFullProfileInfo,
    // experiences,
    // academics,
    // achievements,
    isLoading,
}: MentorPublicProfileCardProps) => (
    // const [mentoredHours, setMentoredHours] = useState<string>('0');
    // useEffect(() => {
    //     if (mentorFullProfileInfo?.totalMentoredMinutes) {
    //         const mentoredTime = mentorFullProfileInfo.totalMentoredMinutes / 60;
    //         setMentoredHours(mentoredTime.toFixed(2));
    //     }
    // }, [mentorFullProfileInfo]);

    <Card
        width={{ base: '100%', sm: '100%', lg: '100%' }}
        minWidth={{ base: '100%', sm: '100%', md: '30vw' }}
        variant="outline"
        boxShadow="none"
        display="flex"
        justifyContent="center"
        alignItems="center"
        position="relative"
        padding={{ base: '6px', sm: '10px', md: '16px', lg: '24px' }}
    >
        {isLoading && (
            <Loader bgColor="loaderBg" height="100%" width="100%" size="lg" position="absolute" />
        )}
        <CardHeader>
            <Flex flexDir="column" gap={1} justifyContent="center" alignItems="center">
                <Avatar
                    // size="2xl"
                    width="150px"
                    height="150px"
                    src={mentorFullProfileInfo?.profileImageUrl ?? ''}
                    name={mentorFullProfileInfo?.name ?? ''}
                />
                <Flex gap={3} alignItems="center">
                    <CustomText color="primary.light" size="3xl" weight={600}>
                        {mentorFullProfileInfo?.name ?? '-'}
                    </CustomText>
                    {mentorFullProfileInfo?.linkedinProfile && (
                        <Link href={mentorFullProfileInfo.linkedinProfile} isExternal>
                            <img
                                src={linkedInLogo.src}
                                alt="LinkedIn Logo"
                                width="28px"
                                height="28px"
                            />
                        </Link>
                    )}
                </Flex>

                <Flex gap={4} alignItems="center">
                    <CustomText color="titleText" size="md" weight={400} lineHeight={6}>
                        {`${mentorFullProfileInfo?.latestExperience?.role ?? '-'}`}
                    </CustomText>
                    {mentorFullProfileInfo?.latestExperience?.company && (
                        <Flex alignItems="center" gap={4}>
                            <Divider
                                orientation="vertical"
                                height="20px"
                                mx={2}
                                borderColor="gray.300"
                            />
                            <Flex gap={2} alignItems="center">
                                {mentorFullProfileInfo?.latestExperience?.logo?.url && (
                                    <CompanyLogo
                                        src={mentorFullProfileInfo.latestExperience.logo.url}
                                        height={28}
                                        width={28}
                                    />
                                )}
                                <CustomText color="mainText" size="md" weight={400}>
                                    {mentorFullProfileInfo.latestExperience?.company}
                                </CustomText>
                            </Flex>
                        </Flex>
                    )}
                </Flex>

                <CustomText
                    color="mainText"
                    size="sm"
                    lineHeight={5}
                    marginTop={2}
                    textAlign="center"
                    weight={400}
                >
                    {parse(mentorFullProfileInfo?.about ?? '')}
                </CustomText>

                {/* <Flex gap={2}>
                        <CustomText color="mainText" size="sm" weight={400}>
                            Reviews
                        </CustomText>
                        <Flex gap={1} alignItems="center">
                            <HiStar color="#ECC94B" size={18} />
                            <CustomText color="#ECC94B" size="sm" weight={500}>
                                {mentorFullProfileInfo?.totalRating ?? 0}
                            </CustomText>
                        </Flex>
                    </Flex> */}
            </Flex>
        </CardHeader>
        {/* <CardBody justifyContent="space-between" width="100%">
                <Stack display="flex" gap={3}>
                    <HStack display="flex" width="100%" justifyContent="space-between">
                        <ProfileInfo label="Total Tutor Time" value={`${mentoredHours} Hrs`} />
                        <Center h={10}>
                            <Divider orientation="vertical" />
                        </Center>
                        <ProfileInfo
                            label="Years of Experience"
                            value={`${mentorFullProfileInfo?.totalExperience?.years ?? 0} Yrs`}
                        />
                        <Center h={10}>
                            <Divider orientation="vertical" />
                        </Center>
                        <ProfileInfo
                            label="Location"
                            value={mentorFullProfileInfo?.currentLocation ?? '-'}
                        />
                    </HStack>
                    <Flex flexWrap="wrap">
                        <CustomTag
                            color="mainText"
                            weight={500}
                            tagBgColor="lightBlueBg"
                            tagBorderColor="primary.light"
                            tagColor="primary.light"
                            heading="Expertise"
                            values={mentorFullProfileInfo?.skills ?? []}
                        />
                    </Flex>
                    <ProfileInfoTabs experiences={experiences} academics={academics} />
                    <Achievements achievements={achievements ?? []} />
                </Stack>
            </CardBody> */}
    </Card>
);

export default MentorPublicProfileCard;
